"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStarCheckIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var RatingStarCheck = function RatingStarCheck(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.25 12.25c-3.033 0-5.5-2.467-5.5-5.5s2.467-5.5 5.5-5.5 5.5 2.467 5.5 5.5-2.468 5.5-5.5 5.5zm0-10c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.686 8.979a.996.996 0 01-.707-.292l-1.083-1.083a.5.5 0 01.708-.707l1.083 1.083 2.157-3.02a.502.502 0 01.9.209.5.5 0 01-.086.373l-2.157 3.02a1.002 1.002 0 01-.815.417zM4.872 23.25a.994.994 0 01-.808-.409 1 1 0 01-.142-.906l2.398-7.202L.587 9.499a.974.974 0 01-.335-.673A1 1 0 011.25 7.75h6.805l2.411-6.354a1.007 1.007 0 011.29-.58 1 1 0 01.58.58l.474 1.253a.502.502 0 01-.936.355L11.4 1.752 8.867 8.428a.502.502 0 01-.467.322H1.25l5.983 5.463c.146.133.2.34.137.527l-2.5 7.51 6.234-4.571a.502.502 0 01.592 0l6.229 4.571-2.5-7.51a.5.5 0 01.146-.535l.885-.77a.503.503 0 01.705.049.501.501 0 01-.049.706l-.634.551 2.395 7.194a1.002 1.002 0 01-.949 1.316c-.212 0-.422-.069-.592-.193L11.4 18.702l-5.938 4.354a.995.995 0 01-.59.194z"
  }));
};
RatingStarCheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const RatingStarCheckIcon = exports.RatingStarCheckIcon = (0, _createIconComponent.default)(RatingStarCheck, 'RatingStarCheck');